/**
 * Coups de pouce — Attendu 1075 « Connaitre les mesures des angles de l'équerre
 * dont dispose l'élève (30° 60° 90° ou 45° 45° 90°) ».
 *
 * angles_saisie + angles_triplet_qcm_unique : entrée PARTAGÉE — reconnaître
 * chaque équerre (côtés égaux ou non, petit angle face au petit côté) et
 * retrouver ses six angles. SVG pas à pas piloté par les flèches de la sheet
 * (data-etapes / data-caption).
 *
 * Sans coup de pouce (pur rappel) : tracer_qcm_unique, vf_tableau_vf.
 */

const SVG_EQUERRES = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 250" width="100%" style="max-width:380px;height:auto;display:block" role="img" data-etapes="3"
     aria-label="Les angles des deux équerres, en 3 étapes à faire défiler avec les flèches. À gauche l'équerre 45-45-90, à droite l'équerre 30-60-90, chacune avec son petit carré. Étape 2 : sur l'équerre de gauche, deux côtés égaux donc deux angles égaux, 45 et 45 degrés, plus 90, total 180. Étape 3 : sur l'équerre de droite, le plus petit angle est en face du plus petit côté, 30 degrés, l'autre angle aigu vaut 60 degrés, plus 90, total 180. 45-45-90 : deux côtés égaux. 30-60-90 : le petit angle face au petit côté">
  <style>
    @keyframes cp1075-pop { from { opacity: 0; } to { opacity: 1; } }
    .cp1075-pop { opacity: 0; animation: cp1075-pop 0.5s ease forwards; }
  </style>
  <!-- sous-titres : un par étape (exclusifs, pilotés par la sheet) -->
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1E3A8A" opacity="1" data-caption="1" font-family="system-ui,sans-serif">Deux équerres, six angles à connaître</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1D9E75" opacity="0" data-caption="2" font-family="system-ui,sans-serif">Deux côtés égaux → deux angles égaux : 45°, 45°, 90°</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#B45309" opacity="0" data-caption="3" font-family="system-ui,sans-serif">Petit angle face au petit côté : 30°, 60°, 90°</text>

  <!-- ── Les deux équerres (étape 1) ─────────────────────────────────── -->
  <g data-etape="1" font-family="system-ui,sans-serif">
    <path d="M 134.0 190.0 L 34.0 90.0 L 34.0 190.0 Z" fill="#fef3c7" stroke="#1E3A8A" stroke-width="2.2"/>
    <polyline points="45.0,190.0 45.0,179.0 34.0,179.0" fill="none" stroke="#111827" stroke-width="1.8"/>
    <line x1="84.0" y1="184.0" x2="84.0" y2="196.0" stroke="#111827" stroke-width="2"/>
    <line x1="28.0" y1="140.0" x2="40.0" y2="140.0" stroke="#111827" stroke-width="2"/>
    <path d="M 314.0 190.0 L 196.0 122.0 L 196.0 190.0 Z" fill="#fef3c7" stroke="#1E3A8A" stroke-width="2.2"/>
    <polyline points="207.0,190.0 207.0,179.0 196.0,179.0" fill="none" stroke="#111827" stroke-width="1.8"/>
    <text x="84" y="214" font-size="11.5" font-weight="700" fill="#1e293b" text-anchor="middle">équerre 45-45-90</text>
    <text x="255" y="214" font-size="11.5" font-weight="700" fill="#1e293b" text-anchor="middle">équerre 30-60-90</text>
  </g>

  <!-- ── L'équerre isocèle (étape 2) ─────────────────────────────────── -->
  <g data-etape="2" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1075-pop">
      <line x1="84.0" y1="184.0" x2="84.0" y2="196.0" stroke="#1D9E75" stroke-width="3"/>
      <line x1="28.0" y1="140.0" x2="40.0" y2="140.0" stroke="#1D9E75" stroke-width="3"/>
      <path d="M 119.9 175.9 L 118.8 177.0 L 117.8 178.2 L 116.9 179.6 L 116.2 180.9 L 115.5 182.3 L 115.0 183.8 L 114.6 185.3 L 114.2 186.9 L 114.1 188.4 L 114.0 190.0" fill="none" stroke="#1D9E75" stroke-width="1.6"/>
      <path d="M 48.1 104.1 L 47.0 105.2 L 45.8 106.2 L 44.4 107.1 L 43.1 107.8 L 41.7 108.5 L 40.2 109.0 L 38.7 109.4 L 37.1 109.8 L 35.6 109.9 L 34.0 110.0" fill="none" stroke="#1D9E75" stroke-width="1.6"/>
      <text x="102.6" y="181.0" font-size="12" font-weight="800" fill="#1D9E75" text-anchor="middle">45°</text>
      <text x="47.0" y="125.4" font-size="12" font-weight="800" fill="#1D9E75" text-anchor="middle">45°</text>
      <text x="55.2" y="172.8" font-size="11" font-weight="800" fill="#1D9E75" text-anchor="middle">90°</text>
      <text x="84" y="60" font-size="11.5" font-weight="700" fill="#1D9E75" text-anchor="middle">deux côtés égaux</text>
      <text x="84" y="74" font-size="11.5" font-weight="700" fill="#1D9E75" text-anchor="middle">→ deux angles égaux</text>
      <text x="84" y="232" font-size="11" font-weight="700" fill="#1D9E75" text-anchor="middle">45 + 45 + 90 = 180 ✓</text>
    </g>
  </g>

  <!-- ── L'autre équerre (étape 3) ───────────────────────────────────── -->
  <g data-etape="3" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1075-pop">
      <line x1="196.0" y1="190.0" x2="196.0" y2="122.0" stroke="#B45309" stroke-width="4"/>
      <path d="M 296.7 180.0 L 296.2 180.9 L 295.7 181.9 L 295.3 182.8 L 295.0 183.8 L 294.7 184.8 L 294.4 185.8 L 294.2 186.9 L 294.1 187.9 L 294.0 189.0 L 294.0 190.0" fill="none" stroke="#B45309" stroke-width="1.6"/>
      <path d="M 213.3 132.0 L 212.2 133.7 L 210.9 135.4 L 209.4 136.9 L 207.8 138.2 L 206.0 139.3 L 204.1 140.3 L 202.2 141.0 L 200.2 141.6 L 198.1 141.9 L 196.0 142.0" fill="none" stroke="#B45309" stroke-width="1.6"/>
      <text x="265.7" y="181.1" font-size="12" font-weight="800" fill="#B45309" text-anchor="middle">30°</text>
      <text x="211.0" y="152.0" font-size="12" font-weight="800" fill="#B45309" text-anchor="middle">60°</text>
      <text x="217.2" y="172.8" font-size="11" font-weight="800" fill="#B45309" text-anchor="middle">90°</text>
      <text x="255" y="60" font-size="11.5" font-weight="700" fill="#B45309" text-anchor="middle">le petit angle (30°) est</text>
      <text x="255" y="74" font-size="11.5" font-weight="700" fill="#B45309" text-anchor="middle">en face du petit côté</text>
      <text x="255" y="88" font-size="11" font-weight="600" fill="#B45309" text-anchor="middle">(l'autre angle aigu vaut 60°)</text>
      <text x="255" y="232" font-size="11" font-weight="700" fill="#B45309" text-anchor="middle">30 + 60 + 90 = 180 ✓</text>
      <text x="180" y="246" font-size="11.5" font-weight="800" fill="#1E3A8A" text-anchor="middle">45-45-90 : côtés égaux. 30-60-90 : petit angle face au petit côté.</text>
    </g>
  </g>

  <text x="180" y="246" font-size="11" font-weight="700" fill="#b45309" text-anchor="middle" opacity="0" data-caption="1" font-family="system-ui,sans-serif">↓ Touche les flèches pour avancer, étape par étape ↓</text>
</svg>`.trim();

const AIDE_EQUERRES = {
    pages: [
        {
            titre: 'La règle',
            lignes: [
                "**Tu as deux équerres, et six angles à connaître** : 30°, 60°, 90° pour l'une ; 45°, 45°, 90° pour l'autre.",
                "**Les deux ont un angle droit** : c'est le coin marqué du petit carré.",
                "**Pour reconnaître l'équerre 45-45-90** : ses deux côtés de l'angle droit ont la même longueur (codés par le même trait), et ses deux angles aigus sont égaux.",
                "**Pour reconnaître l'équerre 30-60-90** : ses deux côtés de l'angle droit sont de longueurs différentes ; le plus petit angle est en face du plus petit côté, c'est 30° ; l'autre angle aigu est 60°.",
                '**Vérifie** : les trois angles font 180° à eux trois.',
            ],
        },
        { titre: 'Un exemple', svg: SVG_EQUERRES },
    ],
};

const CP_1075 = {
    angles_saisie: AIDE_EQUERRES,
    angles_triplet_qcm_unique: AIDE_EQUERRES,
};

export default CP_1075;
